var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 19,
    viewBox: "0 0 13 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.59961 18.167C3.2859 18.167 0.599609 10.0286 0.599609 6.51993C0.599609 3.0113 3.2859 0.166992 6.59961 0.166992C9.91332 0.166992 12.5996 3.0113 12.5996 6.51993C12.5996 10.0286 9.91332 18.167 6.59961 18.167ZM6.59961 16.167C7.03622 16.167 8.07815 14.98 9.01096 12.8552C9.95669 10.7011 10.5996 8.04063 10.5996 6.51993C10.5996 4.09112 8.78238 2.16699 6.59961 2.16699C4.41684 2.16699 2.59961 4.09112 2.59961 6.51993C2.59961 8.04063 3.24253 10.7011 4.18826 12.8552C5.12106 14.98 6.163 16.167 6.59961 16.167ZM8.59961 6.16699C8.59961 7.27156 7.70418 8.16699 6.59961 8.16699C5.49504 8.16699 4.59961 7.27156 4.59961 6.16699C4.59961 5.06242 5.49504 4.16699 6.59961 4.16699C7.70418 4.16699 8.59961 5.06242 8.59961 6.16699Z",
    fill: "#40C5E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c4db91ae6162ff6de82b8287b4089a49.svg";
export { ForwardRef as ReactComponent };